import { useStoreState } from '@ariakit/react';
import { Disclosure, DisclosureContent, useDisclosureStore } from '@ariakit/react/disclosure';
import { createColumnHelper } from '@tanstack/react-table';
import cn from 'classnames';
import { useMemo } from 'react';
import { Spindown } from '#components/atoms/spindown/Spindown.tsx';
import { Table } from '#components/patterns/table/Table.tsx';
import type { DownloadInfo } from '#dn-types/downloads.ts';
import styles from './DownloadRow.module.css';

type Props = {
  version: string;
  date: string;
  downloads: DownloadInfo[];
};

const columnHelper = createColumnHelper<DownloadInfo>();

const columns = [
  columnHelper.accessor('url', {
    size: 350,
    cell(info) {
      const url = info.getValue();
      return (
        <a className="a inline p-md truncate" href={url} download>
          {url}
        </a>
      );
    },
    meta: {
      truncate: true,
    },
  }),
  columnHelper.accessor('OSName', {
    size: 70,
  }),
  columnHelper.accessor('architectureName', {
    size: 200,
  }),
];

/**
 * Row of downloads list
 */
export function DownloadRow({ version, date, downloads }: Props) {
  const disclosure = useDisclosureStore();
  const isOpen = useStoreState(disclosure, 'open');

  const data = useMemo(() => downloads, [downloads]);

  return (
    <div className={styles.DownloadRow}>
      <h3 className="m-0">
        <Disclosure store={disclosure} className={cn('p-md', styles.DownloadRow_disclosure)}>
          <Spindown className={styles.DownloadRow_spindown} isExpanded={isOpen} />v{version} {date}
        </Disclosure>
      </h3>
      <DisclosureContent store={disclosure}>
        <Table className={styles.DownloadRow_table} data={data} columns={columns} />
      </DisclosureContent>
    </div>
  );
}
